module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAIBAMAAAA7P9P/AAAAHlBMVEUAAAD///////////////////////////////////8kfJuVAAAACXRSTlMA1RaqzBW7xMOuwkpjAAAANUlEQVQI12NgYGByCWAAAcWZoiCKSXLmxAAwdyZQAMgF0hMVgFwQEGLwBNNTGBqNjY3N0sQBlowQauv+hf8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiangshang.png
// module id = Xkix
// module chunks = 21